<template>
  <div class="services-products-page w-100">
    <!-- Header Section -->
    <div class="w-100 px-8 py-2 d-flex justify-content-between align-items-center">
        <div class="">
          <h5 class="font-weight-bolder">Dịch vụ & Sản phẩm</h5>
          <p> Quản lý thuốc, Service Package và dịch vụ khám</p>
        </div>
        <div class="d-flex align-items-center">
          <b-button 
           v-if="isInsertPermission && (currentType === 'MEDICINE' || currentType === 'SERVICE')"
            variant="outline-success"
            class="mr-2"
            @click="openImport"
          >
            <i class="ki ki-cloud-upload icon-sm"></i>
            Import Excel
          </b-button>
          <b-button v-if="isInsertPermission" variant="success" @click="openCreatePage" >
            <i class="ki ki-plus icon-sm"></i>
            Thêm {{ getCurrentTypeName() }}
          </b-button>
        </div>
    </div>

    <medicine-import :groups="medicineGroups" @import-success="onImportSuccess" />
    <service-import :providers="providerOptions" @import-success="onImportSuccess" />

    <div class="mx-7">
      <b-card no-body class="border-bottom-0">
        <b-tabs
          v-model="activeTab"
          nav-wrapper-class="bg-white p-3 border-bottom"
          content-class="p-0"
          no-body
          @activate-tab="onTabActivate"
        >
          <b-tab>
            <template #title>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-capsule" viewBox="0 0 16 16">
                <path d="M1.828 8.9 8.9 1.827a4 4 0 1 1 5.657 5.657l-7.07 7.071A4 4 0 1 1 1.827 8.9Zm9.128.771 2.893-2.893a3 3 0 1 0-4.243-4.242L6.713 5.429z"/>
              </svg>
              <span class="ml-2">Thuốc &amp; TPCN</span>
              <b-badge variant="success" class="ml-2">{{ summary.medicine }}</b-badge>
            </template>
          </b-tab>

          <b-tab>
            <template #title>
               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard2-data" viewBox="0 0 16 16">
                <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z"/>
                <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z"/>
                <path d="M10 7a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm4-3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1"/>
              </svg>
              <span class="ml-2">Service Package</span>
              <b-badge variant="success" class="ml-2">{{ summary.servicePackage }}</b-badge>
            </template>
          </b-tab>

          <b-tab>
            <template #title>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hospital" viewBox="0 0 16 16">
                  <path d="M8.5 5.034v1.1l.953-.55.5.867L9 7l.953.55-.5.866-.953-.55v1.1h-1v-1.1l-.953.55-.5-.866L7 7l-.953-.55.5-.866.953.55v-1.1zM13.25 9a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zM13 11.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25zm.25 1.75a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm-11-4a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 3 9.75v-.5A.25.25 0 0 0 2.75 9zm0 2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zM2 13.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25z"/>
                  <path d="M5 1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 1 1v4h3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1zm2 14h2v-3H7zm3 0h1V3H5v12h1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm0-14H6v1h4zm2 7v7h3V8zm-8 7V8H1v7z"/>
                </svg>
              <span class="ml-2">Dịch vụ</span>
              <b-badge variant="success" class="ml-2">{{ summary.service }}</b-badge>
            </template>
          </b-tab>
        </b-tabs>
      </b-card>
      
      <!-- Content Section - sát với tabs -->
      <b-card no-body class="border-top-0" style="border-top-left-radius: 0; border-top-right-radius: 0;">
        <div class="card-body">
          <b-overlay :show="loading">
            <!-- Search and Filter -->
            <b-row class="mb-4 align-items-center">
              <b-col cols="4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-light border-right-0">
                      <i class="flaticon2-search-1 text-muted"></i>
                    </span>
                  </div>
                  <input
                    v-model="searchText"
                    type="text"
                    class="form-control border-left-0"
                    :placeholder="getSearchPlaceholder()"
                    @input="handleSearchDebounce"
                  />
                </div>
              </b-col>
             
            </b-row>

            <b-row>
              <b-col 
                v-for="item in items" 
                :key="item.id" 
                cols="12" 
                class="mb-4"
              >
                <b-card no-body class="card-custom">
                  <div class="card-body p-4">
                    <div class="d-flex align-items-start">
                      <div class="symbol symbol-50 symbol-light-success mr-4 flex-shrink-0">
                        <span class="symbol-label">
                          <i :class="getItemIcon(currentType)" class="icon-lg text-success"></i>
                        </span>
                      </div>
                      
                      <div class="flex-grow-1">
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="flex-grow-1">
                            <div class="d-flex align-items-center mb-2">
                              <h5 class="text-dark font-weight-bolder mb-1 mr-4">
                                {{ item.name }}
                              </h5>
                              <p v-if="currentType === 'MEDICINE'" class="font-weight-bolder px-2 py-1  rounded-pill mb-0 mr-2" style="background-color: #E8F6F0; color: #16A34A;">
                                {{ item.isMedicine ? 'Thuốc' : 'Sản phẩm hỗ trợ' }}
                              </p>
                               <p v-if="currentType === 'MEDICINE'" class="font-weight-medium px-2 py-1  rounded-pill mb-0" style="background-color: #F5F6F7; color: #364153;">
                                {{ item.code || '' }}
                              </p>
                              <p  v-if="currentType === 'SERVICE'"  class="font-weight-bolder px-2 py-1  rounded-pill mb-0 mr-2" style="background-color: #f3e8ff; color: #8200db;">
                              {{ getAppFeatureName(item.appFeature) }}
                              </p>
                               
                            </div>
                           
                            <div class="text-muted mb-2" v-if="currentType === 'MEDICINE'">
                              <strong>Mã nhóm:</strong> {{ getMedicineGroupName(item.medicineGroupId) }} |
                              <strong>Tên viết tắt:</strong> {{ item.shortName }}
                            </div>
                             <div class="text-muted mb-2" v-if="currentType === 'MEDICINE'">
                              <strong>Hàm lượng:</strong> {{ item.strength }} mg
                            </div>
                            <div class="text-muted mb-2" v-if="currentType === 'SERVICE_PACKAGE'">
                              <strong>Thời lượng:</strong> {{ item.totalWeek }} tuần
                            </div>
                            <div class="text-muted mb-2" v-if="currentType === 'SERVICE'">
                              <strong>Thời gian:</strong> {{ item.minutes }} phút |
                              <strong>Nhà cung cấp:</strong> <span class="font-weight-bolder px-2 py-1  rounded-pill mb-0 mr-2" style="background-color: #f3e8ff; color: #8200db; font-size: 0.825rem;"> {{ getProviderName(item.serviceProviderId) }} </span>
                            </div>
                            <div class="text-muted mb-2">
                              {{ item.description }}
                            </div>
                          </div>
                          <button v-if="isUpdatePermission" @click="editItem(item)" class="pointer px-4 py-2 bg-secondary rounded-lg border-0">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                              </svg>
                              <span class="ml-2">Sửa</span>
                          </button>
                        </div>
                        
                        <div class="d-flex align-items-center mt-3 pt-3 border-top">
                          <div class="text-success font-weight-bolder font-size-lg">
                            {{ formatCurrency(item.price ?? item.money) }}
                            </div>
                          <div class="text-muted font-size-sm ml-2" v-if="item.createDatetime">
                            Tạo lúc {{ formatDate(item.createDatetime) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
              </b-col>
            </b-row>



            <div v-if="paging.total > 0" class="d-flex justify-content-between align-items-center mt-4">
              <div class="d-flex align-items-center">
                <b-form-select
                  v-model="paging.pageSize"
                  :options="pageSizeOptions"
                  size="sm"
                  class="page-size-select"
                  style="width: 80px;"
                ></b-form-select>
              </div>
              <b-pagination
                v-model="paging.page"
                :total-rows="paging.total"
                :per-page="paging.pageSize"
                size="md"
                class="mb-0 pagination-custom"
                first-number
                last-number
              ></b-pagination>
            </div>

           
          </b-overlay>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { APP_FEATURE_OPTIONS } from './constants/clinicBundleConstants';
import MedicineImport from './components/modal/MedicineImport.vue';
import ServiceImport from './components/modal/ServiceImport.vue';

export default {
  name: 'ServicesProducts',
  components: { MedicineImport, ServiceImport },
  data() {
    return {
      activeTab: 0,
      currentType: 'MEDICINE',
      loading: false,
      searchText: '',
      searchTimer: null,

      summary: {
        medicine: 0,
        servicePackage: 0,
        service: 0,
      },

      medicineGroups: [],

      providerOptions: [],

      items: [],

      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },

      pageSizeOptions: [
        { value: 5,  text: '5' },
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
      ],
    };
  },

  computed: {
    searchParams() {
      const payload = this.removeEmpty({
        name: this.searchText || null,
        page: this.paging.page,
        size: this.paging.pageSize,
      });
      const params = new URLSearchParams();
      for (const property in payload) {
        params.append(property, payload[property]);
      }
      return params;
    },
  },

  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.paging.page = 1;
      this.loadData();
    },
  },

  mounted() {
    this.loadData();
  },

  activated() {
    this.loadData();
  },

  beforeDestroy() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },

  methods: {
    removeEmpty(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(([, v]) => v !== null && v !== undefined && v !== ''),
      );
    },

    async loadData() {
      try {
        this.loading = true;
        if (this.currentType === 'MEDICINE') {
          await this.loadMedicineGroups();
          await this.loadMedicineItems();
        } else if (this.currentType === 'SERVICE_PACKAGE') {
          await this.loadServicePackageData();
        } else if (this.currentType === 'SERVICE') {
          await this.loadProviders();
          await this.loadServiceData();
        }
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi', msg: error });
      } finally {
        this.loading = false;
      }
    },

    async loadMedicineGroups() {
      if (this.medicineGroups.length === 0) {
        try {
          const { data } = await this.$api.get('BundleMedicineGroup/All');
          this.medicineGroups = (data || []).map((g) => ({
            value: g.id,
            text: g.name,
          }));
        } catch (error) {
          console.error('Error loading medicine groups:', error);
        }
      }
    },

    async loadMedicineItems() {
      const { data } = await this.$api.get('BundleMedicine', { params: this.searchParams });
      const list = Array.isArray(data) ? data : (data?.items ?? data?.data ?? []);
      this.items = list;
      this.paging.total = Array.isArray(data) ? data.length : (data?.total ?? list.length);
      this.summary.medicine = this.paging.total;
    },

    async loadServicePackageData() {
      const { data } = await this.$api.get('ServicePackage', {
        params: this.searchParams,
      });
      const list = Array.isArray(data) ? data : (data?.items ?? data?.data ?? []);
      this.items = list;
      this.paging.total = Array.isArray(data) ? data.length : (data?.total ?? list.length);
      this.summary.servicePackage = this.paging.total;
    },

    async loadServiceData() {
      const { data } = await this.$api.get('BundleService', {
        params: this.searchParams,
      });
      const list = Array.isArray(data) ? data : (data?.items ?? data?.data ?? []);
      this.items = list;
      this.paging.total = Array.isArray(data) ? data.length : (data?.total ?? list.length);
      this.summary.service = this.paging.total;
    },

      async loadProviders() {
      try {
        const { data } = await this.$api.get('/ServiceProvider/All');
        this.providerOptions = (data || []).map((item) => ({
          value: item.id,
          text: item.name,
        }));
      } catch (e) {
        console.error('Không thể tải danh sách nhà cung cấp:', e);
      }
    },

    onTabActivate(newIndex) {
      const typeMap = ['MEDICINE', 'SERVICE_PACKAGE', 'SERVICE'];
      this.changeTab(typeMap[newIndex] || 'MEDICINE');
    },

    changeTab(type) {
      this.currentType = type;
      this.searchText = '';
      this.items = [];
      this.loadData();
    },

    handleSearchDebounce() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        this.paging.page = 1;
        this.loadData();
      }, 2000);
    },

    resetFilters() {
      this.searchText = '';
      this.paging.page = 1;
      this.loadData();
    },

    handleSearch() {
      this.paging.page = 1;
      this.loadData();
    },

    openCreatePage() {
      const routes = {
        MEDICINE: { name: 'medicine_create' },
        SERVICE_PACKAGE: { name: 'service_package_create' },
        SERVICE: { name: 'service_create' },
      };
      const targetRoute = routes[this.currentType];
      if (!targetRoute) {
        this.$toastr.error('Không thể tạo mới ' + this.getCurrentTypeName(), 'Lỗi');
        return;
      }
      if (this.currentType === 'MEDICINE') {
        sessionStorage.setItem('medicineGroups', JSON.stringify(this.medicineGroups));
      }
      this.$router.push(targetRoute);
},
    editItem(item) {
      const routes = {
        MEDICINE: 'medicine_edit',
        SERVICE_PACKAGE: 'service_package_edit',
        SERVICE: 'service_edit',
      };
      const storageKeys = {
        MEDICINE: 'medicine_edit_item',
        SERVICE_PACKAGE: 'service_package_edit_item',
        SERVICE: 'service_edit_item',
      };
      const routeName = routes[this.currentType];
      const storageKey = storageKeys[this.currentType];
      if (storageKey) {
        sessionStorage.setItem(storageKey, JSON.stringify(item));
      }
      if (routeName) {
        const params = { id: item.id };
        if (this.currentType === 'MEDICINE') {
          sessionStorage.setItem('medicineGroups', JSON.stringify(this.medicineGroups));
        }
        this.$router.push({ name: routeName, params });
      }
    },

    getSearchPlaceholder() {
      const placeholders = {
        MEDICINE: 'Tìm kiếm thuốc & TPCN...',
        SERVICE_PACKAGE: 'Tìm kiếm gói dịch vụ...',
        SERVICE: 'Tìm kiếm dịch vụ khám...',
      };
      return placeholders[this.currentType] || 'Tìm kiếm...';
    },

    getCurrentTypeName() {
      const typeNames = {
        MEDICINE: 'thuốc & TPCN',
        SERVICE_PACKAGE: 'gói dịch vụ',
        SERVICE: 'dịch vụ khám',
      };
      return typeNames[this.currentType] || 'sản phẩm';
    },

    getItemIcon(type) {
      const icons = {
        MEDICINE: 'flaticon2-medical-records',
        SERVICE_PACKAGE: 'flaticon2-layers-1',
        SERVICE: 'flaticon2-cardiogram',
      };
      return icons[type] || 'flaticon2-medical-records';
    },

    formatCurrency(value) {
      if (!value) return '0 VNĐ';
      return new Intl.NumberFormat('vi-VN').format(value) + ' VNĐ';
    },

    getAppFeatureName(appFeature) {
      const option = APP_FEATURE_OPTIONS.find((o) => o.value === appFeature);
      return option ? option.text : 'Không';
    },

    getMedicineGroupName(groupId) {
      if (!groupId) return '—';
      const group = this.medicineGroups.find((g) => g.value === groupId);
      return group ? group.text : groupId;
    },

    getProviderName(providerId) {
      if (!providerId) return '—';
      const provider = this.providerOptions.find((p) => p.value === providerId);
      return provider ? provider.text : providerId;
    },

    openImport() {
      if (this.currentType === 'MEDICINE') {
        this.$bvModal.show('modal-bundle-medicine-import');
      } else if (this.currentType === 'SERVICE') {
        this.$bvModal.show('modal-bundle-service-import');
      }
    },

    onImportSuccess() {
      this.medicineGroups = [];
      this.loadData();
    },

    formatDate(timestamp) {
      if (!timestamp) return '';
      const ms = typeof timestamp === 'number' && timestamp < 1e12 
        ? timestamp * 1000  
        : timestamp;        
      return this.$moment(ms).format('DD/MM/YYYY');
    },
  },
};
</script>

<style scoped lang="scss">
.services-products-page {
  .symbol {
    &-light-primary {
      background-color: #e1f0ff;
      color: #10b981;
    }
  }

  ::v-deep .nav-tabs {
    .nav-item {
      .nav-link {
        color: #6c757d;
        border-color: transparent;

        &:hover {
          color: #21a567;
        }

        &.active {
          color: #21a567 !important;
          background-color: white;
          border-color: #e4e6ea #e4e6ea #fff;
        }
      }
    }
  }

  .label {
    display: inline-block;
    padding: 0.5rem 1rem;
    border-radius: 0.42rem;
    font-weight: 500;

    &-light-success {
      background-color: #c9f7f5;
      color: #1bc5bd;
    }
  }

  .card-custom {
    border: 1px solid #ebedf3;
    border-radius: 0.42rem;
    transition: all 0.15s ease;

    &:hover {
      border-color: #21a567;
      box-shadow: 0 2px 6px 0 rgba(33, 165, 103, 0.15);
    }
  }

  .input-group {
    .input-group-text {
      background-color: #f8f9fa;
      border-color: #e4e6ea;
    }

    .form-control {
      border-color: #e4e6ea;
    }
  }

  .page-size-select {
    border-color: #dee2e6;
    font-size: 0.875rem;
  }

  ::v-deep .pagination-custom {
    .page-item {
      &.active .page-link {
        background-color: #01645A;
        border-color: #01645A;
        color: #fff;
      }
      .page-link {
        color: #21a567;
        &:hover {
          background-color: #e8f8f0;
          border-color: #21a567;
          color: #21a567;
        }
      }
    }
  }

}
</style>